<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar Unidad</h5>
        </div>        
        <emt-form ref="unit-form" v-bind:resource="config.api + '/unit/'" v-bind:items="itemsForm" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'

export default{
    name: 'emt-form-edit-unit',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre unidad',
                    'placeholder': 'Ingrese nombre de unidad',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'notification',
                    'label': 'Alerta inicial (Días)',
                    'placeholder': 'Alerta inicial (Días)',
                    'value': null,
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'notification_end',
                    'label': 'Alerta final (Días)',
                    'placeholder': 'Alerta final (Días)',
                    'value': null,
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'days',
                    'label': 'Días ANS',
                    'value': null,
                    'placeholder': 'Días ANS',
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            config: Config,
            update: true
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getData(Config.api + '/unit/')
    },
    methods: {
        getData: function (url) {
            url = url + this.$route.params.id + '/'
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body)
            }, function (response) {
            })
        },
        setValue: function (value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name]
            }
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-unit.vue?4b006620